<template>
  <div class="activity-wrap">
    <app-header />
    <p class="time"></p>
    <div class="mod">
      <h2 class="title">《大智慧365》限时6折</h2>
      <p>点一点体验大佬们都看哪些功能</p>
      <span class="btn-buy" @click="goUrl(116)">立即购买</span>
      <div class="mod-nav">
        <span v-for="(nav, index) in listOne.nav" :key="index" :class="{cur: curIndexOne === index}" @click="curIndexOne = index">{{nav}}</span>
      </div>
      <div class="con">
        <img :src="listOne.imgList[curIndexOne]" alt="">
      </div>
    </div>
    <div class="mod">
      <h2 class="title">《大智慧策略投资终端》</h2>
      <p>点一点体验大佬们都看哪些功能</p>
      <span class="money">38000/年 </span>
      <span class="btn-buy" @click="goUrl(113)">立即购买</span>
      <div class="mod-nav">
        <span v-for="(nav, index) in listTwo.nav" :key="index" :class="{cur: curIndexTwo === index}" @click="curIndexTwo = index">{{nav}}</span>
      </div>
      <div class="con">
        <img :src="listTwo.imgList[curIndexTwo]" alt="">
      </div>
    </div>
    <div class="mod yxMod">
      <h2 class="title title2">限时购《优选大师财富版》1年，<br>即得《大智慧财富版PC》软件1年</h2>
      <span class="btn-buy" @click="goUrl(197)">立即购买</span>
      <div class="con">
        <img src="../../assets/images/activity/activity202109/img3.jpg">
      </div>
    </div>
    <div class="note">
      <p> 活动日期：9月6日至9月29日，10月8日-10月30日</p>
      <p>活动须知：大智慧策略投资终端，老用户购买优选大师财富版不赠送大智慧财富版年卡</p>
    </div>
    <div class="tips">投资有风险，入市须谨慎。</div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',
      curIndexOne: 0,
      listOne: {
        nav: ['全推level 2', '四维战法', '北向资金', '热点轮动'],
        imgList: [
          require("@/assets/images/activity/activity202109/1-1.png"),
          require("@/assets/images/activity/activity202109/1-2.png"),
          require("@/assets/images/activity/activity202109/1-3.png"),
          require("@/assets/images/activity/activity202109/1-4.png")
        ]
      },
      curIndexTwo: 0,
      listTwo: {
        nav: ['ACE资金', '热点轮动', '优选500', '机构热股'],
        imgList: [
          require("@/assets/images/activity/activity202109/2-1.png"),
          require("@/assets/images/activity/activity202109/2-2.png"),
          require("@/assets/images/activity/activity202109/2-3.png"),
          require("@/assets/images/activity/activity202109/2-4.png")
        ]
      }
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {
    
  },
  methods: {
    goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month:12}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    },
  }
}
</script>
<style lang="scss" scoped>
.activity-wrap{
  background: url(../../assets/images/activity/activity202109/bg1.jpg) no-repeat center 100px ,
              url(../../assets/images/activity/activity202109/bg2.jpg) no-repeat center 900px #c33526;
  .time{
    margin: 475px auto 135px;
    width: 290px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #f4b570;
    font-size: 30px;
    // background: #bc3b37;
    border-radius: 30px;
  }
  .mod{
    width: 1200px;
    margin: 0 auto 76px;
    background: #fecda3;
    border-radius: 20px;
    box-shadow: 0 0 20px 10px rgba($color: #770005, $alpha: 0.42);
    position: relative;
    padding: 140px 20px 45px;
    &.yxMod{
      padding-top: 180px;
      margin-bottom: 50px;
    }
    .title{
      font-size: 60px;
      color: #fefefe;
      background: url(../../assets/images/activity/activity202109/title1.png) no-repeat;
      width: 827px;
      height: 152px;
      position: absolute;
      left: -24px;
      top: -26px;
      line-height: 140px;
      padding-left: 95px;
      font-style: italic;
    }
    .title2{
      background: url(../../assets/images/activity/activity202109/title2.png) no-repeat;
      width: 907px;
      height: 172px;
      line-height: 60px;
      font-size: 46px;
      top: -25px;
      padding-left: 117px;
      padding-top: 15px;;
    }
    >p{
      color: #d66244;
      font-size: 30px;
    }
    .mod-nav{
      overflow: hidden;
      margin: 35px 0 20px;
      span{
        width: 180px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #f7b987;
        color: #d66244;
        float: left;
        font-size: 30px;
        margin-right: 18px;
        cursor: pointer;
        border-radius: 8px;
        &.cur{
          color: #fff;
          background: #ec652f;
        }
      }
    }
    .btn-buy{
      position: absolute;
      top: 30px;
      right: 50px;
      width: 240px;
      height: 70px;
      line-height: 70px;
      display: block;
      color: #fff;
      font-size: 36px;
      text-align: center;
      background-image: linear-gradient(to bottom, #f58d7f, #c92a32);
      box-shadow: 0 3px 8px 4px rgba($color: #e46862, $alpha: 0.6);
      border-radius: 40px;
      cursor: pointer;
    }
    .money{
      position: absolute;
      top: 48px;
      right: 315px;
      font-size: 30px;
      color: #cf383d;
    }
    .con{
      img{
        display: block;
        max-width: 100%;
        margin: 0 auto;
      }
    }
  }
  .note{
    color: #6D000E;
    font-size: 18px;
    width: 1200px;
    margin: 0 auto;
    line-height: 36px;
    span{
      float: left;
    }
    p{
      // padding-left: 80px;
      em{
        color: #fff;
      }
    }
  }
  .tips{
    background: #b03022;
    padding: 40px 0;
    font-size: 24px;
    color: #f1824c;
    text-align: center;
    margin-top: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202109.vue